import { render, staticRenderFns } from "./PricingCardStyle4.vue?vue&type=template&id=4c1b2ace&scoped=true"
import script from "./PricingCardStyle4.vue?vue&type=script&lang=js"
export * from "./PricingCardStyle4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1b2ace",
  null
  
)

export default component.exports